export const SHOP_PAGARME_STAGING_GATEWAY_ID = 23;
export const SHOP_PAGARME_PRODUCTION_GATEWAY_ID = 24;
export const MERCADO_PAGO_ACTIVITIES_BASE_URL =
  'https://www.mercadopago.com.br/activities?q=';

export type ShopPaymentGatewaySource = {
  id?: string | number | null;
  order_id?: string | null;
  orderId?: string | null;
  pagarMeOrderId?: string | null;
  acquirer_name?: string | null;
  acquirerName?: string | null;
  paymentProvider?: string | null;
};

export class GatewayUtil {
  static gatewayUrl = {
    10: 'https://beta.dashboard.sandbox.pagar.me/#/transactions/',
    11: 'https://beta.dashboard.pagar.me/#/transactions/',
    20: 'https://dashboard.belvo.com/production/payments/intents/',
    21: 'https://dash.pagar.me/merch_N1nrOnr5I4t5Oz5y/acc_4owGvq6HgcwrNZyL/orders/',
    22: 'https://dash.pagar.me/merch_N1nrOnr5I4t5Oz5y/acc_KrqADEvI6asg4bJ0/orders/',
    23: 'https://dash.pagar.me/merch_OpnrOLosWSmj4qyl/acc_7AoV5q2C27foMVjK/orders/',
    24: 'https://dash.pagar.me/merch_OpnrOLosWSmj4qyl/acc_DG7mzBBUe3iqmKjl/orders/',
    31: 'https://dash.pagar.me/merch_N1nrOnr5I4t5Oz5y/acc_EMkl95ZCeIvXrdDa/orders/',
    32: 'https://dash.pagar.me/merch_N1nrOnr5I4t5Oz5y/acc_WNdPj6tzntxjPYMy/orders/'
  };

  static shopPaymentGatewayUrl(
    payment: ShopPaymentGatewaySource | null | undefined,
    isProduction: boolean
  ): string | null {
    if (!payment) {
      return null;
    }

    if (GatewayUtil.isShopPagarMePayment(payment)) {
      const pagarMeOrderId = GatewayUtil.shopPagarMeOrderId(payment);
      if (!pagarMeOrderId) {
        return null;
      }
      const gatewayId = isProduction
        ? SHOP_PAGARME_PRODUCTION_GATEWAY_ID
        : SHOP_PAGARME_STAGING_GATEWAY_ID;
      const baseUrl = GatewayUtil.gatewayUrl[gatewayId];
      return baseUrl ? `${baseUrl}${pagarMeOrderId}` : null;
    }

    if (GatewayUtil.isShopMercadoPagoPayment(payment)) {
      if (
        payment.id === null ||
        payment.id === undefined ||
        payment.id === ''
      ) {
        return null;
      }
      return `${MERCADO_PAGO_ACTIVITIES_BASE_URL}${payment.id}`;
    }

    return null;
  }

  private static shopPaymentAcquirer(payment: ShopPaymentGatewaySource): string {
    return String(
      payment.acquirer_name ||
        payment.acquirerName ||
        payment.paymentProvider ||
        ''
    ).toLowerCase();
  }

  private static shopPagarMeOrderId(
    payment: ShopPaymentGatewaySource
  ): string | null {
    const orderId =
      payment.order_id || payment.orderId || payment.pagarMeOrderId;
    if (typeof orderId === 'string' && orderId.startsWith('or_')) {
      return orderId;
    }
    return null;
  }

  private static isShopPagarMePayment(
    payment: ShopPaymentGatewaySource
  ): boolean {
    const paymentId = String(payment.id ?? '');
    return (
      GatewayUtil.shopPaymentAcquirer(payment).includes('pagar') ||
      paymentId.startsWith('ch_') ||
      GatewayUtil.shopPagarMeOrderId(payment) != null
    );
  }

  private static isShopMercadoPagoPayment(
    payment: ShopPaymentGatewaySource
  ): boolean {
    if (GatewayUtil.shopPaymentAcquirer(payment).includes('mercado')) {
      return true;
    }
    return /^\d+$/.test(String(payment.id ?? '').trim());
  }
}
